const NotificationType = {
  GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
  GET_NOTIFICATION: 'GET_NOTIFICATION',
}

export default NotificationType
